import { Box, Button, Link, Stack, Typography } from '@mui/material'
import { palette } from '../../myTheme'
import MCImage1 from '../../components/images/framedMCImage1.png'
import MCImage2 from '../../components/images/FramedMCImage2.png'
import useMediaQuery from '@mui/material/useMediaQuery'

const imageArray = [MCImage1, MCImage2]

export default function TCAppPage() {
  const isScreenSmall = useMediaQuery('(max-width: 1000px)')
  return (
    <Box margin={isScreenSmall ? 6 : 12}>
      <Stack spacing={8}>
        <Stack
          direction='row'
          style={{
            paddingBottom: 8,
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <Typography fontWeight={800} fontSize={isScreenSmall ? 18 : 70}>
            Making Cents: tip calculator
          </Typography>
          <Button
            style={{
              marginTop: isScreenSmall ? 0 : 13,
              maxHeight: isScreenSmall ? 40 : 80,
              fontSize: isScreenSmall ? 16 : 30,
            }}
            onClick={() => window.history.back()}
          >
            Back
          </Button>
        </Stack>

        <Link
          href="https://apps.apple.com/us/app/making-cents-tip-calculator/id6747083021"
          target="_blank"
          underline="none"
          style={{
            color: palette.white,
            fontWeight: 600,
            fontSize: isScreenSmall ? 16 : 24,
            textDecoration: 'none',
          }}
        >
          Click Here to Download on the App Store
        </Link>

        <Typography
          style={{ textAlign: isScreenSmall ? 'center' : 'start' }}
          fontStyle={{ color: palette.white }}
          fontWeight={400}
          fontSize={isScreenSmall ? 14 : 20}
        >
          This is a lightweight and fully featured tip calculator and bill
          splitter. You can evenly split a bill and tip for up to 20 people.
          This app also features a round up feature to round your bill up to the
          nearest dollar if you so desire. Built with SwiftUI it is incredibly
          lightweight and performant.
        </Typography>
        <Stack
          direction="row"
          spacing={6}
          style={{
            overflowX: isScreenSmall ? 'auto' : 'visible',
            flexWrap: isScreenSmall ? 'nowrap' : 'wrap',
            scrollSnapType: isScreenSmall ? 'x mandatory' : 'none',
            justifyContent: 'space-evenly'
          }}
        >
          {imageArray.map((imgSrc, index) => (
            <Box
              key={index}
              component="img"
              src={imgSrc}
              alt={`Image ${index}`}
              sx={{
                height: 450,
                borderRadius: 2,
                flexShrink: 0,
                scrollSnapAlign: isScreenSmall ? 'start' : 'none',
              }}
            />
          ))}
        </Stack>

      </Stack>
    </Box>
  )
}
